<template>
  <div class="short-answer-container">
    <div class="question-stem">{{question.Question}}</div>
    <div class="helper-text">{{question.HelperText}}</div>
    <div class="answer">{{response()}}</div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    selectedTeacher: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      teacher: this.$props.selectedTeacher || {
        employeeId: "",
        responses: []
      }
    };
  },
  methods: {
    response() {
      const response = this.teacher.responses.filter(
        res => res.QuestionID === this.question.QuestionID
      );
      return response.length === 0 ? `No Answer` : response[0].Comment;
    }
  }
};
</script>

<style scoped>
.question-stem {
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #000000;
  margin-bottom: 0.75em;
  max-width: 90%;
  line-height: 1.2;
}
.answer {
  font-family: Arial;
  font-size: 1em;
  text-align: justify;
  color: #4a4a4a;
  border-bottom: 1px solid grey;
  padding: 0.25em;
}
@media only screen and (min-width: 1200px) {
  .question-stem {
    font-family: Arial;
    font-size: 1.25em;
    text-align: justify;
    color: #000000;
    margin-bottom: 0.75em;
    line-height: 1.2;
  }
  .answer {
    font-family: Arial;
    font-size: 1.1em;
    text-align: justify;
    color: #4a4a4a;
    border-bottom: 1px solid grey;
    padding: 0.25em;
  }
}
.short-answer-container {
  margin-bottom: 3.5em;
  padding-left: 0.5em;
}
</style>